import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { Equipment, OperationType, Product, Routing, TId, Workcenter, Workforce } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-products-routings-edit',
    templateUrl: './products-routings-edit.component.html',
    styleUrls: ['./products-routings-edit.component.sass'],
    standalone: false
})
export class ProductsRoutingsEditComponent extends GenericCrudEditComponent<Routing> {

  @Input() productSelected: Product = {} as Product;

  operations: any[]
  allEquipments: Equipment[]
  allWorkforces: Workforce[]
  allWorkcenters: Workcenter[]
  allOperationTypes: OperationType[]

  constructor() {
    super();
    this.resource = this.api.resources.product.routings;
    this.operations = []
    this.allEquipments = []
    this.allWorkforces = []
    this.allWorkcenters = []
    this.allOperationTypes = []
  }

  protected override async preFetch(): Promise<void> {
    await this.getEquipments()
    await this.getWorkforces()
    await this.getWorkcenters()
    await this.getOperations()
    await this.getOperationTypes()
  }
  protected override onInitExtendActions(): void {
    // //this.foo()
    // this.getEquipments()
    // this.getWorkforces()
    // this.getWorkcenters()
    // this.getOperations()
    // this.getOperationTypes()
  }

  initFormGroup(): FormGroup {
    const group = this.fb.group({
      id: [this.entity!.id],
      code: [this.productSelected.code],
      productId: [this.productSelected!.name],
      routeName: [this.entity!.name],
      version: [this.entity!.version]
    });
    return group;
  }
  async getEquipments(): Promise<void> {
    const equipments = await firstValueFrom(this.api.resources.equipments.getAll())
    this.allEquipments = equipments
  }
  async getWorkforces(): Promise<void> {
    const workforces = await firstValueFrom(this.api.resources.workforces.getAll())
    this.allWorkforces = workforces
  }
  async getWorkcenters(): Promise<void> {
    const workcenters = await firstValueFrom(this.api.resources.workcenters.getAll())
    this.allWorkcenters = workcenters
  }
  async getOperationTypes(): Promise<void> {
    const operationTypes = await firstValueFrom(this.api.resources.operations.operationTypes.getAll())
    this.allOperationTypes = operationTypes
  }
  async getOperations(): Promise<void> {
    const operations = await firstValueFrom(this.api.getOperationsByRoutingId(this.entity!.id))
    this.operations = operations
  }

  async open(operation: any): Promise<void> {
  }

  getWorkForceNameById(workForceId: TId) : string {
    return this.allWorkforces?.find(x => x.id === workForceId)?.name ?? '';
  }

  getEquipmentNameById(equipmentId: TId) : string {
    return this.allEquipments?.find(x => x.id === equipmentId)?.name ?? '';
  }

  displayEntity(): string {
    return this.entity!.name;
  }
}

